import { MantineTheme, CSSObject } from '@mantine/core';

const inputHeight = '2.2rem';

export const getCommonFieldStyles = (theme: MantineTheme): Record<string, CSSObject> => {
    return {
        root: {
            position: 'relative'
        },
        input: {
            height: 'auto',
            // paddingTop: 20,
            lineHeight: inputHeight,
            paddingTop: 4,
            paddingBottom: 4,
            // fontWeight: 400,
            fontWeight: 500,
            fontSize: '0.95rem',
            span: {
                display: 'block',
                minHeight: inputHeight,
                // fontWeight: 400,
                fontWeight: 500,
                fontSize: '0.95rem'
            },
            '::placeholder': {
                fontWeight: 400
            }
        },
        inputHighlight: {
            borderColor: theme.colors.orange[5]
        },
        inputWrapperInline: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            justifyContent: 'flex-start'
        },
        halfWidth: {
            width: '50%'
        },
        leftGroupPosition: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        rightGroupPosition: {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            '&:not(:focus)': {
                borderLeftColor: 'transparent'
            }
        },
        middleGroupPosition: {
            borderRadius: 0,
            '&:not(:focus)': {
                borderLeftColor: 'transparent'
            }
        },
        readonlyInput: {
            cursor: 'default',
            pointerEvents: 'none',
            borderColor: 'transparent',
            paddingLeft: '0 !important',
            paddingRight: 0
            // background: '#f5f5f5'
        },
        label: {
            // position: 'absolute',
            // pointerEvents: 'none',
            // fontSize: theme.fontSizes.sm,
            // paddingLeft: theme.spacing.sm,
            // paddingTop: '1px',
            // zIndex: 1,
            // // fontWeight: 700,
            // lineHeight: '1.9rem',
            fontWeight: 500,
            fontSize: theme.fontSizes.md,
            color: theme.colors.dark[4]
        },
        labelHighlight: {
            color: theme.colors.orange[7]
        },
        required: {
            // float: 'left'
        },
        readonlyRequired: {
            display: 'none'
        },
        hiddenDisplay: {
            display: 'none'
        },
        icon: {
            height: `calc(${inputHeight} + 8px)`,
            maxHeight: `calc(${inputHeight} + 8px)`
        },
        error: {
            position: 'absolute',
            top: '100%',
            marginTop: '-0.3rem'
        },
        wrapper: {
            marginTop: 'calc(0.625rem / 2)',
            marginBottom: 'calc(0.625rem / 2)',
            paddingBottom: '0.5rem'
        },
        readonlyWrapper: {
            marginTop: '0',
            marginBottom: '0',
            paddingBottom: '0'
        },
        description: {
            color: theme.colors.dark[3]
        }
    };
};
